import { useEffect, useState } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import Chip from "@mui/material/Chip"
import MDBox from "components/MDBox"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import DataTable from "monitor/Tables/DataTable"
import Icon from "@mui/material/Icon"
import { Link, useNavigate } from "react-router-dom"
import config from "config"
import MDButton from "components/MDButton"

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import MDTypography from "components/MDTypography"
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import ModalSelector from "components/ModalSelector"

function Zonas() {
  const [data, setData] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [eventos, setEventos] = useState([])
  const [selectedEmpresas, setSelectedEmpresas] = useState("")
  const [selectedSucursales, setSelectedSucursales] = useState("")
  const [selectedEventos, setSelectedEventos] = useState("")
  const [nombre, setNombre] = useState("")
  const [expandedRows, setExpandedRows] = useState({})
  const navigate = useNavigate()

  const columns = [
    { Header: "Item", accessor: "item", width: "5%" },
    { Header: "Nombre", accessor: "descripcion", width: "25%" },
    { Header: "Empresa", accessor: "empresa.descripcion", width: "10%" },
    { Header: "Sucursal", accessor: "sucursales", width: "15%" },
    { Header: "Evento", accessor: "eventos", width: "15%" },
    { Header: "Cod. Zona", accessor: "codigoZona", width: "10%" },
    { Header: "Activo", accessor: "activo", width: "10%" },
    { Header: "Acciones", accessor: "action", align: "center", width: "10%" },
  ]

  const getEmpresas = async () => {
    try {
      let empUrl = `${config.api.baseURL}/empresas`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        if (result) {
          setEmpresas(result)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchSucursales = async (selectedId) => {
    try {
      if (selectedId) {
        let sucuUrl = `${config.api.baseURL}/sucursales/empresa/${selectedId}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSelectedSucursales("")
          if (result) {
            setSucursales(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchEventos = async (selectedId) => {
    try {
      if (selectedId) {
        let sucuUrl = `${config.api.baseURL}/eventos/empresa/${selectedId}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSelectedEventos("")
          if (result) {
            setEventos(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleEmpresasChange = (e) => {
    const selectedId = e.target.value
    setSelectedEmpresas(selectedId)
    fetchSucursales(selectedId)
    fetchEventos(selectedId)
  }

  const fetchZonas = async (setData) => {
    try {
      let url = `${config.api.baseURL}/zonas?`

      if (selectedEmpresas) {
        url += `empresaId=${encodeURIComponent(selectedEmpresas)}&`
      }
      if (selectedSucursales) {
        url += `sucursalId=${encodeURIComponent(selectedSucursales)}&`
      }
      if (selectedEventos) {
        url += `eventoId=${encodeURIComponent(selectedEventos)}&`
      }
      if (nombre) {
        url += `nombre=${encodeURIComponent(nombre)}&`
      }

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        const rowsWithColumns = addColumns(result)
        setData(rowsWithColumns)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
  useEffect(() => {
    fetchZonas(setData)
  }, [expandedRows])

  const toggleExpanded = (idZona) => {
    setExpandedRows((prev) => ({
      ...prev,
      [idZona]: !prev[idZona],
    }))
  }

  function addColumns(dataColumns) {
    let c = 0
    return dataColumns.map((d) => {
      const idZona = d.idZona
      const isExpanded = expandedRows[idZona]

      return {
        ...d,
        item: ++c,
        activo: d.activo ? (
          <Chip label="Si" color="success" variant="outlined" />
        ) : (
          <Chip label="No" color="error" variant="outlined" />
        ),
        sucursales: (
          <MDBox
            display="flex"
            flexWrap="wrap"
            gap={1}
            sx={{ width: "200px", overflow: "hidden", whiteSpace: "nowrap" }}
          >
            {(isExpanded ? d.sucursales : d.sucursales?.slice(0, 5))?.map((sucursal, index) => (
              <Chip key={index} label={sucursal.descripcion} color="primary" variant="outlined" />
            ))}
            {d.sucursales?.length > 5 && (
              <Chip
                label={isExpanded ? "ver menos" : "ver todo"}
                onClick={() => toggleExpanded(idZona)}
                color="info"
                variant="outlined"
                sx={{ cursor: "pointer" }}
              />
            )}
          </MDBox>
        ),
        eventos: (
          <MDBox
            display="flex"
            flexWrap="wrap"
            gap={1}
            sx={{ width: "200px", overflow: "hidden", whiteSpace: "nowrap" }}
          >
            {d.eventos?.map((evento, index) => (
              <Chip key={index} label={evento.descripcion} color="primary" variant="outlined" />
            ))}
          </MDBox>
        ),
        action: (
          <MDBox>
            <MDButton
              sx={{ mr: 1 }}
              variant="gradient"
              color="success"
              iconOnly
              onClick={() => handleEdit(idZona)}
            >
              <Icon>edit</Icon>
            </MDButton>
            <MDButton
              variant="gradient"
              color="error"
              iconOnly
              onClick={() => handleDelete(idZona)}
            >
              <Icon>delete</Icon>
            </MDButton>
          </MDBox>
        ),
      }
    })
  }

  function handleDelete(id) {
    Swal.fire({
      title: "¿Está seguro que desea eliminar este zona?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = `${config.api.baseURL}/zonas/${id}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Zona eliminado exitosamente", icon: "success" })
              fetchZonas(setData)
            } else {
              // Attempt to parse error message from server
              response
                .json()
                .then((errorData) => {
                  console.log(errorData)
                  showToast({
                    icon: "error",
                    title: "Error",
                    text: errorData.error || "No se pudo eliminar la zona.",
                  })
                })
                .catch(() => {
                  // Fallback if parsing fails
                  showToast({ icon: "error", title: "Error", text: "Ocurrió un error al eliminar la zona." })
                })
            }
          })
          .catch((error) => {
            showToast({ icon: "error", title: "Error", text: error.message || "Error de conexión" })
          })
      }
    })
  }

  function handleEdit(id) {
    navigate(`/zonas/${id}`)
  }

  const handleNombreSearch = (event) => {
    const term = event.target.value
    setNombre(term)
  }

  const handleBuscar = async () => {
    await fetchZonas(setData)
  }

  const resetValues = () => {
    setSelectedEmpresas("")
    setSelectedSucursales("")
    setSelectedEventos("")
    setNombre("")
  }

  const handleClearFilters = () => {
    resetValues() // Reset all filter states
  }

  useEffect(() => {
    console.log("useEffect called")

    fetchZonas(setData)
    getEmpresas()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6}>
        <Grid container>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDTypography variant="h6" color="text" gutterBottom>
                Filtros
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      label="Empresa"
                      variant="outlined"
                      fullWidth
                      value={selectedEmpresas}
                      onChange={handleEmpresasChange}
                      sx={{ p: 1.5 }}
                      placeholder="Seleccione.."
                    >
                      <MenuItem value="">Ninguna</MenuItem>
                      {empresas.map((emp) => (
                        <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                          {emp.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <ModalSelector
                    value={selectedSucursales}
                    onChange={setSelectedSucursales}
                    items={sucursales}
                    itemValue="idSucursal"
                    itemLabel="descripcion"
                    label="Sucursal"
                    placeholder="Seleccione una sucursal"
                    searchPlaceholder="Buscar sucursal..."
                    emptyText="No se encontraron sucursales"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Evento</InputLabel>
                    <Select
                      label="Evento"
                      variant="outlined"
                      fullWidth
                      value={selectedEventos}
                      onChange={(e) => setSelectedEventos(e.target.value)}
                      sx={{ p: 1.5 }}
                      placeholder="Seleccione.."
                    >
                      <MenuItem value="">Ninguna</MenuItem>
                      {eventos?.map((sucu) => (
                        <MenuItem key={sucu.idEvento} value={sucu.idEvento}>
                          {sucu.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    value={nombre}
                    onChange={handleNombreSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleNombreSearch(event)
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <MDBox>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        onClick={handleBuscar}
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={handleClearFilters}
                      >
                        Limpiar
                      </MDButton>
                    </MDBox>

                    <Link to="/zonas/agregar" style={{ textDecoration: "none" }}>
                      <MDButton type="button" variant="gradient" color="success">
                        Agregar
                      </MDButton>
                    </Link>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <MDBox pt={3}>
              <Card sx={{ p: 2 }}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Zonas
